import {
  getPageTimeLogsFromSessionStorage,
  getTimesOfEachPageReloadedBetweenMilisecondsOfTolerance,
  maxTimesThatPageCanReloadBetweenTolerance,
  timeInMilisecondsOfTolerance,
} from "shared/utils/monitoringInfiniteReloadingUtils";

import { captureException, captureMessage } from "@sentry/nextjs";

export const shouldShowStopReloadingAlert = (): boolean => {
  let shouldStop = false;

  try {
    const currentPagePath = window?.location?.href;
    const pageLogsFromSessionStorage = getPageTimeLogsFromSessionStorage();
    const timeOfEachPageRealodedBetweenMilisecondsOfTolerance =
      getTimesOfEachPageReloadedBetweenMilisecondsOfTolerance({
        pageLogs: pageLogsFromSessionStorage,
        timeOfTolerance: timeInMilisecondsOfTolerance,
      });

    const timesOfCurrentPageReloaded =
      timeOfEachPageRealodedBetweenMilisecondsOfTolerance[currentPagePath];

    shouldStop =
      timesOfCurrentPageReloaded >= maxTimesThatPageCanReloadBetweenTolerance;
  } catch (error) {
    console.log("Error (shouldShowStopReloadingAlert): ", error);
    captureException(error);
    captureMessage("Error (shouldShowStopReloadingAlert)");
  }

  return shouldStop;
};
